import React, { memo } from 'react';
import { AnimateHeight } from '@surveycake/rc';
import { useDatePickerAnswer } from './hooks';
import Picker from './Picker';
import Display from './Display';

function Answer() {
  const { date, min, max, open, toggleOpen, onChange } = useDatePickerAnswer();

  return (
    <div>
      <Display date={date} onClick={toggleOpen} />
      <AnimateHeight height={open ? 'auto' : 0}>
        <Picker date={date} min={min} max={max} onChange={onChange} />
      </AnimateHeight>
    </div>
  );
}

export default memo(Answer);
